module.exports = __webpack_public_path__ + "img/ldap.3bc173db.svg";